<template>
  <div>fotobücher!!!</div>
</template>

<script>
export default {

}
</script>

<style>

</style>